export const selectWaitingRooms = (state) => state.data.waitingRooms.waitingRooms;

// eslint-disable-next-line
export const selectWaitingRoom = (state, id) => state.data.waitingRooms.waitingRooms.find((waitingRoom) => waitingRoom.id == id);
export const selectExistingWaitingRoom = (state) => state.data.waitingRooms.waitingRooms[0];
export const selectWaitingRoomViewInfo = (state, id) => state.data.waitingRooms.waitingRoomViewInfo[id] || {};
export const selectWaitingRoomChart = (state, id) => state.data.waitingRooms.charts[id] || [];
export const selectCreateWaitingRoomFormData = (state) => state.data.waitingRooms.forms.createWaitingRoom;
